import React from "react";
import { useParams } from "react-router-dom";
import StartReviewForm from "./components/StartReviewForm";

const StartReview = () => {
    const { reviewId } = useParams();

    return (
        <div className="mt-5 grid h-full grid-cols-1 gap-4">
            <StartReviewForm recordId={reviewId} />
        </div>
    );
};

export default StartReview;